import React from "react";
import "./QuantityStepper.css";
import { ReactComponent as PlusIcon } from "../../assets/icons/plus.svg";
import { ReactComponent as MinusIcon } from "../../assets/icons/minus.svg";

export interface QuantityStepperProps {
  value: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange: (value: number) => void;
  className?: string;
}

export const QuantityStepper: React.FC<QuantityStepperProps> = ({
  value,
  min = 0,
  max = Infinity,
  disabled = false,
  onChange,
  className = ""
}) => {
  const canDecrement = !disabled && value > min;
  const canIncrement = !disabled && value < max;

  const handleDecrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (canDecrement) {
      onChange(value - 1);
    }
  };

  const handleIncrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (canIncrement) {
      onChange(value + 1);
    }
  };

  return (
    <div className={`quantity_stepper ${disabled ? "disabled" : ""} ${className}`}>
      <button
        type="button"
        className="stepper_btn decrement"
        onClick={handleDecrement}
        disabled={!canDecrement}
        aria-label="Decrease quantity"
      >
        <MinusIcon className="stepper_icon" />
      </button>
      <span className="stepper_value">{value}</span>
      <button
        type="button"
        className="stepper_btn increment"
        onClick={handleIncrement}
        disabled={!canIncrement}
        aria-label="Increase quantity"
      >
        <PlusIcon className="stepper_icon" />
      </button>
    </div>
  );
};

export default QuantityStepper;
